export const dealWithScenarioKey = "dealWithScenarioKey";

export const addDealWithScenario = (dealName, scenarioSelected) => {
  const newObj = {
    id: dealName,
    scenario: scenarioSelected
  };

  let jsonData = loadDataFromStorageByKey(dealWithScenarioKey, true);

  if (!jsonData) {
    const arr = [];
    arr.push(newObj);
    saveStorageByKey(dealWithScenarioKey, arr);
  } else {
    const item = jsonData.find(it => it.id === dealName);

    if (item) {
      if (!scenarioSelected) {
        // If deal without scenario - remove it
        jsonData = jsonData.filter(it => it.id !== dealName);
      }

      item.scenario = scenarioSelected;
    } else {
      jsonData.push(newObj);
    }

    saveStorageByKey(dealWithScenarioKey, jsonData);
  }
}

export const getScenarioByDeal = (dealName) => {
  const jsonData = loadDataFromStorageByKey(dealWithScenarioKey, true);
  if (!jsonData) {
    return null;
  }
  const item = jsonData.find(it => it.id === dealName);
  return item ? item.scenario : null;
}

export const loadDataFromStorageByKey = (key, isJson) => {
  return isJson ? localStorage[key] ? JSON.parse(localStorage[key]) : null : localStorage[key];
}

export const saveStorageByKey = (key, data) => {
  localStorage.setItem(key, JSON.stringify(data));
}
